<template>
    <b-row class="tests-page-content test-wizard">
        <b-col cols="12" md="12" lg="3">
            <tests-wizard-nav></tests-wizard-nav>
        </b-col>
        <b-col cols="12" md="12" lg="9">
            <tests-wizard-image-step v-if="currentStep === 'image'" @setImageError="setImageError"></tests-wizard-image-step>
            <tests-wizard-area-step v-if="currentStep === 'area'"></tests-wizard-area-step>
            <tests-wizard-testers-step v-if="currentStep === 'testers'"></tests-wizard-testers-step>
            <tests-wizard-payment-step v-if="currentStep === 'payment'"></tests-wizard-payment-step>
            <tests-wizard-summary-step v-if="currentStep === 'summary'"></tests-wizard-summary-step>
        </b-col>
    </b-row>

</template>

<script>
    import {errors} from '../../mixins/errors';
    import Test from "../../classes/models/Test";

    export default {
        name: 'tests-wizard',
        props: ['testId'],
        mixins: [errors],
        beforeRouteEnter(to, from, next) {
            if (!to.params.testId) {
                window._store.commit('tests/clearCurrentTest');
                return next();
            }
            window._store.dispatch('tests/show', to.params.testId).then(next).catch(e => {
                // [Nick] TODO: Add errors handling
                return next({
                    name: 'tests_active'
                });
            });
            gtag('require', 'ec');
        },
        beforeRouteUpdate(to, from, next) {
            if (!to.params.testId) {
                window._store.commit('tests/clearCurrentTest');
                return next();
            }
            window._store.dispatch('tests/show', to.params.testId).then(next).catch(e => {
                // [Nick] TODO: Add errors handling
                return next({
                    name: 'tests_active'
                });
            });
        },
        data() {
            return {
                currentStep: 'image',
                stepsMap: {
                    1: 'image',
                    2: 'area',
                    3: 'testers',
                    4: 'payment',
                    5: 'summary',
                },
                test: new Test(),
                ownTestersPrice: process.env.MIX_OWN_TESTERS_PRICE
            }
        },
        created() {
            this.initCurrentState();
            this.$store.watch((state) => {
                return state.tests.currentTest;
            }, () => {
                this.initCurrentState();
            })
        },
        computed: {
            currentStepNumber() {
                const invertedMap = _.invert(this.stepsMap);
                return parseInt(invertedMap[this.currentStep]) || 1;
            }
        },
        methods: {
            nextStep() {
                const step = this.stepsMap[this.currentStepNumber + 1];
                if (!step) {
                    return;
                }
                this.currentStep = step;
            },
            previousStep() {
                const step = this.stepsMap[this.currentStepNumber - 1];
                if (!step) {
                    return;
                }
                this.currentStep = step;
            },
            toStep(step) {
                this.currentStep = step;
            },
            saveTest(successCb, failedCb) {
                if (this.test.id) {
                    return this.updateTest();
                }
                this.createTest(successCb, failedCb);
            },
            createTest(successCb, failedCb) {
                let formData = {url: this.test.url};
                if (this.test.imageToUpload) {
                    formData = new FormData();
                    formData.append('image', this.test.imageToUpload);
                }

                this.$store.dispatch('tests/store', formData).then((test) => {
                    if (successCb) {
                        successCb();
                    }
                    this.$router.push({name: 'test_edit', params: {testId: test.id}});
                }).catch(e => {
                    if (failedCb) {
                        failedCb();
                    }
                    this.handleResponseErrors(e);
                });
            },
            updateTest() {
                if (!this.test.image) {
                    delete this.test.image;
                }
                let imagePromise = new Promise(function (resolve) {
                    return resolve();
                });
                if (this.test.imageToUpload) {
                    let formData = new FormData();
                    formData.append('image', this.test.imageToUpload);
                    imagePromise = this.$store.dispatch('tests/uploadImage', {test: this.test, payload: formData});
                }
                imagePromise.then(() => {
                    return this.$store.dispatch('tests/update', this.test);
                }).then(() => {
                    this.nextStep();
                }).catch(e => {
                    this.handleResponseErrors(e);
                });
            },
            initCurrentState() {
                let currentTest = _.cloneDeep(this.$store.getters['tests/getCurrentTest']) || new Test();

                if (currentTest.id !== this.test.id) {
                    switch (true) {
                        case !currentTest.id:
                        case !currentTest.image_url && !currentTest.url:
                            this.currentStep = 'image';
                            break;
                        case !currentTest.areas || currentTest.areas.length < 1:
                            this.currentStep = 'area';
                            break;
                        case !((currentTest.eligibility_requirement_attributes.length > 0 || currentTest.predefined_panel_id) && currentTest.package_id) && !currentTest.own_testers:
                            this.currentStep = 'testers';
                            break;
                        case currentTest.status === 'draft':
                            this.currentStep = 'payment';
                            break;
                        default:
                            this.currentStep = 'summary';
                            break;
                    }
                }

                Vue.set(this, 'test', currentTest);
            },
            setImageError(error) {
                this.errors.image = error;
                this.errors.attachments = error;
            }

        }
    }
</script>

<style scoped>

</style>
